import styled from 'styled-components';

export const StyledWrapper = styled.div`
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
`;

export const StyledContainer = styled.div`
  margin-left: 112px;
  margin-right: 112px;
  padding-bottom: 256px;

  @media screen and (max-width: 1440px) {
    margin-left: 64px;
    margin-right: 64px;
  }

  @media screen and (max-width: 1250px) {
    margin-left: 32px;
    margin-right: 32px;
  }

  @media (max-width: 767px) {
    margin-left: unset;
    margin-right: unset;
    padding-bottom: 144px;
  }
`;

export const StyledTitle = styled.h3`
  font-family: 'Fuse V.2 Display';
  font-weight: 800;
  font-size: 112px;
  line-height: 120px;
  color: white;
  max-width: 696px;
  margin-top: 0;
  margin-bottom: 80px;

  @media (max-width: 767px) {
    font-size: 56px;
    line-height: 60px;
    margin-bottom: 48px;
    margin-left: 24px;
    margin-right: 24px;
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const StyledFeaturesListWrapper = styled.div`
  width: 488px;
  margin-right: 20px;

  & > div {
    &:not(:last-child) {
      margin-bottom: 40px;
      padding-bottom: 40px;
      border-bottom: thin solid rgba(256, 256, 256, 0.32);
    }
  }

  @media (max-width: 767px) {
    margin-right: unset;
    width: 100%;
    margin-bottom: 84px;
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const StyledFeatureHeader = styled.div`
  display: flex;
  position: relative;

  & > h4 {
    font-family: 'Fuse V.2 Display';
    font-weight: 800;
    font-size: 36px;
    line-height: 44px;
    color: #ffffff;
    margin-top: 0;
    margin-bottom: 0;

    &:first-child {
      margin-right: 16px;
    }
  }
`;

export const StyledArrow = styled.img`
  position: absolute;
  right: 0;
  top: 16px;
  transition: transform 200ms ease;
  cursor: pointer;

  ${({ isActive }) => !isActive && 'transform: rotate(180deg);'}
`;

export const StyledFeatureDescription = styled.p`
  font-family: 'Fuse V.2 Display';
  font-size: 16px;
  line-height: 24px;
  color: white;
  margin-top: 16px;
  margin-bottom: 0;
`;

export const StyledImage = styled.img`
  border-radius: 32px;

  @media screen and (max-width: 1000px) {
    width: 50%;
    height: auto;
  }

  @media (max-width: 767px) {
    border-radius: 0;
    width: 100%;
  }
`;
